import type { IExtractParams } from "@routes/types.ts";
import { generatePath } from "@routes/utils.ts";

const memberCoursesPathBase = `/members/:memberId/courses/`;
const memberCoursesPathById = `${memberCoursesPathBase}:courseId/`;
const courseChapterPathBase = `${memberCoursesPathById}chapters/`;
const courseChapterPathById = `${courseChapterPathBase}:chapterId/`;
const chapterContentPathBase = `${courseChapterPathById}contents/`;
const chapterContentPathById = `${chapterContentPathBase}:contentId/`;

export type IMemberCoursePathParam = IExtractParams<
  typeof memberCoursesPathBase
>;
export type ICoursePathParam = IExtractParams<typeof memberCoursesPathById>;
export type ICourseChapterPathParam = IExtractParams<
  typeof courseChapterPathById
>;
export type ICourseChapterContentPathParam = IExtractParams<
  typeof chapterContentPathById
>;

export const course = {
  getAll: (param: IMemberCoursePathParam) =>
    generatePath(memberCoursesPathBase, param),
  post: (param: IMemberCoursePathParam) =>
    generatePath(memberCoursesPathBase, param),
  get: (param: ICoursePathParam) => generatePath(memberCoursesPathById, param),
  put: (param: ICoursePathParam) => generatePath(memberCoursesPathById, param),
  patch: (param: ICoursePathParam) =>
    generatePath(memberCoursesPathById, param),
  delete: (param: ICoursePathParam) =>
    generatePath(memberCoursesPathById, param),
  chapters: {
    getAll: (param: ICoursePathParam) =>
      generatePath(courseChapterPathBase, param),
    post: (param: ICoursePathParam) =>
      generatePath(courseChapterPathBase, param),
    get: (param: ICourseChapterPathParam) =>
      generatePath(courseChapterPathById, param),
    put: (param: ICourseChapterPathParam) =>
      generatePath(courseChapterPathById, param),
    patch: (param: ICourseChapterPathParam) =>
      generatePath(courseChapterPathById, param),
    delete: (param: ICourseChapterPathParam) =>
      generatePath(courseChapterPathById, param),
    contents: {
      getAll: (param: ICourseChapterPathParam) =>
        generatePath(chapterContentPathBase, param),
      post: (param: ICourseChapterPathParam) =>
        generatePath(chapterContentPathBase, param),
      get: (param: ICourseChapterContentPathParam) =>
        generatePath(chapterContentPathById, param),
      put: (param: ICourseChapterContentPathParam) =>
        generatePath(chapterContentPathById, param),
      patch: (param: ICourseChapterContentPathParam) =>
        generatePath(chapterContentPathById, param),
      delete: (param: ICourseChapterContentPathParam) =>
        generatePath(chapterContentPathById, param),
    },
  },
};
